import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import { store } from "@store";
import App from "./App";
import "./index.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "@store";
import { OverlayProvider } from "./context/OverlayContext";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <OverlayProvider>
          <BrowserRouter>
            <React.Suspense fallback={<div>Loading...</div>}>
              <App />
            </React.Suspense>
          </BrowserRouter>
        </OverlayProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
);
